import { render, staticRenderFns } from "./NewsInteractionCard.vue?vue&type=template&id=1f5f51fc&scoped=true&"
import script from "./NewsInteractionCard.vue?vue&type=script&lang=js&"
export * from "./NewsInteractionCard.vue?vue&type=script&lang=js&"
import style0 from "./NewsInteractionCard.vue?vue&type=style&index=0&id=1f5f51fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5f51fc",
  null
  
)

export default component.exports